import { RestMethod } from "../../../_helpers/ApiConfig/RestMethod";
import FilterResponse from "../../../_helpers/FilterResponse";
import { customToastr } from "../../../_Pages/_webapp/arya2.0/CustomToastr";

const callApi = async (api, Method, data) => {
  try {
    const response = await RestMethod[Method](api, data);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response.data;
  } catch (error) {
    customToastr({
      text: "Something went wrong. Please try again later",
      type: "error",
    });
    console.log("error detected while fetching data from api");
    return null;
  }
};

export const getListing = async (urlParamString = "/warehouse") => {
  return callApi(`/v2/wishlist${urlParamString ? urlParamString : ""}`, "GET");
};

export const deleteFromWishlist = async (data) => {
  return callApi(`/v2/wishlist-remove`, "POST", data);
};

export const addToWishlist = async (data) => {
  return callApi(`v2/wishlist`, "POST", data);
};

export const getLiveAuctionsFromAPI = async (
  urlParamString = "/v2/auction/list?offset=0&limit=10&filters=[{%22status%22:[1]}]"
) => {
  return callApi(urlParamString, "GET");
};
